// Production configuration and feature flags

const NODE_ENV = process.env.NODE_ENV || 'development';
const PUBLIC_ENV = process.env.REACT_APP_DEPLOY_ENV || NODE_ENV;
const IS_STAGING = PUBLIC_ENV === 'staging';
const ENABLE_PUBLIC_SHOP = process.env.REACT_APP_ENABLE_PUBLIC_SHOP === 'true';

export const CONFIG = {
  // Environment
  NODE_ENV,
  PUBLIC_ENV,
  IS_STAGING,
  
  // API Configuration
  API_BASE_URL: '/api',
  
  // Feature Flags
  FEATURES: {
    ENABLE_LOGGING: NODE_ENV === 'development',
    ENABLE_ANALYTICS: NODE_ENV === 'production',
    ENABLE_ERROR_REPORTING: NODE_ENV === 'production',
    ENABLE_PERFORMANCE_MONITORING: true,
    ENABLE_OFFLINE_SUPPORT: true,
    ENABLE_LIVE_SCRAPING: NODE_ENV === 'production',
    ENABLE_PUBLIC_SHOP
  },
  
  // Timeouts and Limits
  API_TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
  
  // Cache Configuration
  CACHE_DURATION: {
    INGREDIENTS: 5 * 60 * 1000, // 5 minutes
    RECIPES: 10 * 60 * 1000, // 10 minutes
    CONTACTS: 2 * 60 * 1000, // 2 minutes
    SEARCH_RESULTS: 30 * 60 * 1000 // 30 minutes
  },
  
  // UI Configuration
  UI: {
    PAGINATION_SIZE: 20,
    SEARCH_DEBOUNCE_MS: 500,
    TOAST_DURATION: 5000,
    LOADING_DELAY: 200 // Show loading spinner after 200ms
  },
  
  // Error Messages
  ERROR_MESSAGES: {
    NETWORK_ERROR: 'Kunde inte ansluta till servern. Kontrollera din internetanslutning.',
    AUTHENTICATION_ERROR: 'Autentisering misslyckades. Vänligen logga in igen.',
    PERMISSION_ERROR: 'Du har inte behörighet att utföra denna åtgärd.',
    VALIDATION_ERROR: 'Vänligen kontrollera att alla fält är korrekt ifyllda.',
    SERVER_ERROR: 'Ett serverfel uppstod. Försök igen senare.',
    TIMEOUT_ERROR: 'Begäran tog för lång tid. Försök igen.',
    GENERIC_ERROR: 'Ett oväntat fel uppstod. Kontakta support om problemet kvarstår.'
  },
  
  // Validation Rules
  VALIDATION: {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE_REGEX: /^[+]?[0-9\s\-()]{7,15}$/,
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 50,
    MESSAGE_MIN_LENGTH: 10,
    MESSAGE_MAX_LENGTH: 1000
  },
  
  // Third-party Services
  SERVICES: {
    MATHEM_BASE_URL: 'https://www.mathem.se',
    MATHEM_SEARCH_URL: 'https://www.mathem.se/se/search/products/',
    MATHEM_TIMEOUT: 15000
  }
};

// Helper functions
export const isProduction = () => CONFIG.NODE_ENV === 'production';
export const isDevelopment = () => CONFIG.NODE_ENV === 'development';
export const isStaging = () => CONFIG.IS_STAGING;
export const isFeatureEnabled = (feature) => CONFIG.FEATURES[feature] || false;
export const isPublicShopEnabled = () => isFeatureEnabled('ENABLE_PUBLIC_SHOP');

// Environment validation
export const validateEnvironment = () => {
  return { valid: true, errors: [] };
};

// Performance monitoring configuration
export const getPerformanceConfig = () => ({
  enabled: isFeatureEnabled('ENABLE_PERFORMANCE_MONITORING'),
  slowOperationThreshold: 2000, // 2 seconds
  memoryThreshold: 50 * 1024 * 1024, // 50MB
  reportingInterval: 60000 // 1 minute
});

// Security headers for production
export const getSecurityHeaders = () => ({
  'X-Content-Type-Options': 'nosniff',
  'X-Frame-Options': 'DENY',
  'X-XSS-Protection': '1; mode=block',
  'Referrer-Policy': 'strict-origin-when-cross-origin',
  'Content-Security-Policy': "default-src 'self'; img-src 'self' data: https:; style-src 'self' 'unsafe-inline'; script-src 'self';"
});

export default CONFIG;
